import { type AutoBatchOptions } from '@reduxjs/toolkit';

/**
 * A customised redux enhancer to notify UI updates
 * Redux Default behaviour is to use requestAnimationFrame alone.
 * When a browser tab doesnt have focus, The API call is made but the response is not available
 * until the tab is focused at least once.
 * To fix this, We use a combination of requestAnimationFrame and queueMicrotask to ensure that the UI is updated
 * either by queueMicrotask or by requestAnimationFrame.
 * @see https://github.com/reduxjs/redux-toolkit/issues/5051
 */
export const opinionatedAutoBatch: AutoBatchOptions = {
  type: 'callback',
  queueNotification(notify) {
    let executed = false;
    let rafId: number;

    const executor = () => {
      if (executed) return;

      executed = true;
      cancelAnimationFrame(rafId);
      notify();
    };

    rafId = requestAnimationFrame(executor);
    queueMicrotask(executor);
  },
};
